// extracted by mini-css-extract-plugin
export var cardLayout = "_a5-1";
export var paginationContainer = "_a5-0";